/** Projection configurations */
export const PROJECTIONS = {
  naturalEarth: { name: 'Natural Earth', scale: 128, translateY: 0 },
  mercator: { name: 'Mercator', scale: 100, translateY: 40 },
  equalEarth: { name: 'Equal Earth', scale: 128, translateY: 0 },
} as const

export type ProjectionType = keyof typeof PROJECTIONS

/** Marker colours */
export const MARKER_COLORS = {
  dc: '#2563EB',
  vault: '#E35D2B',
  arc: '#7F77DD',
} as const

/** Continent fills — light mode */
export const CONTINENT_FILLS_LIGHT: Record<string, string> = {
  Europe: '#dde6f8',
  Asia: '#d8ece0',
  Africa: '#f0e8d8',
  'North America': '#e8ddf0',
  'South America': '#d8f0ec',
  Oceania: '#f0dde2',
  Other: '#e8e8e4',
}

/** Continent fills — dark mode */
export const CONTINENT_FILLS_DARK: Record<string, string> = {
  Europe: '#1e2438',
  Asia: '#1e3028',
  Africa: '#2a2418',
  'North America': '#241e30',
  'South America': '#182a28',
  Oceania: '#2a1e22',
  Other: '#222222',
}

/** Map chrome colours */
export const MAP_CHROME = {
  light: { stroke: '#c0beb6', background: '#fafaf8' },
  dark: { stroke: '#3a3a44', background: '#141416' },
}

/** Zoom config */
export const ZOOM = {
  min: 1,
  max: 64,
  step: 1.5,
  labelThreshold: 3,
}
